import { serviceApi } from '~/api';

export const getAddressSuggestionsUrl = (postcode) => `address-suggestions?postcode=${postcode}`;

const getAddressSuggestions = (postcode) =>
  serviceApi.fetchJSON(getAddressSuggestionsUrl(postcode), {
    method: 'GET',
  });

const fetchAddresses = (searchQuery) =>
  getAddressSuggestions(searchQuery).then(({ suggestions: addresses }) =>
    Promise.resolve(addresses),
  );

export const getAddressUrl = (addressId) => `addresses/${addressId}`;

const getAddress = (addressId) =>
  serviceApi.fetchJSON(getAddressUrl(addressId), {
    method: 'GET',
  });

const fetchAddress = (addressId) =>
  getAddress(addressId).then((address) => Promise.resolve(address));

export const addressesApi = {
  fetchAddresses,
  fetchAddress,
};
